<template>
  <div id="dc_customize" class="parent_div">
    <div class="wrapper">
      <dd-header
        ref="menuRef"
        :headerType=2
        :cartCount="nowList? nowList.length : 0"
        :isDcPriceDisp="!userInfo.isProfitFlag"
      />
      <div class="container">
        <div id="product" class="left_container">
          <div id="category">
            <span @click="goCategory()">
              <img :src="getImage('common/left_arrow.svg')">
              <figcaption>商品カテゴリに戻る</figcaption>
            </span>
            <span>
              <img :src="categoryImgBlack(targetPlan.categoryImg)">
              <figcaption>{{targetPlan.categoryName}}</figcaption>
            </span>
          </div>
          <div id="product-big-image">
            <img :src="getImage(targetPlan.dcFdImageB)">
          </div>
          <div class="product_detail_area">
            <div class="product_detail">
              <div class="big_text">
                <div>{{targetPlan.corpData.corpName}}</div>
                <div>{{targetPlan.seriesName}}</div>
              </div>
              <div class="big_text">
                <div class="bold">{{targetPlan.dcFdName}}</div>
                <div class="pickup bold">{{productSize(targetPlan.dcMinWidth, targetPlan.dcMaxWidth)}}</div>
              </div>
            </div>
            <!-- <div class="select_list" >
              <div @click="onMenu()">資料を見る</div>
              <nav v-bind:class="{active: isMenuActive}" @mouseover="isOnMenu=true" @mouseout="isOnMenu=false">
                <ul>
                  <li v-for="(manual,index) in manualList" :key="'manual-' + index" @click="previewManual(manual)">{{manual.name}}</li>
                </ul>
              </nav>
            </div> -->
          </div>
          <div class="manual bold">
            <span @click="downloadManual(targetPlan.cDcProductManual)" v-bind:class="{disabled : !targetPlan.cDcProductManual}">
              <img :src="getImage('common/PDF.svg')">
              <figcaption>商品説明書</figcaption>
            </span>
            <span @click="downloadManual(targetPlan.cDcConstructManual)" v-bind:class="{disabled : !targetPlan.cDcConstructManual}">
              <img :src="getImage('common/PDF.svg')">
              <figcaption>設置説明書</figcaption>
            </span>
            <span @click="downloadManual(targetPlan.cDcUserManual)" v-bind:class="{disabled : !targetPlan.cDcUserManual}">
              <img :src="getImage('common/PDF.svg')">
              <figcaption>取扱説明書</figcaption>
            </span>
          </div>
          <div id="construct">
            <h2>施工事例 <span class="small_text" v-if="false">(クリックすると寸法・色柄が自動入力されます）</span></h2>
            <dd-consturct
              ref="ddCategoryListRef"
              :swipeList="constructList"
              :swiperOptions="constructOptions"
              :horizontalMode="false"
              @previewConstruct="previewConstruct"
            />
          </div>
        </div>
        <div id="customize" class="right_container">
          <div class="title">
            <img :src="getImage('common/spanner.svg')">
            <h2>➌ カスタマイズ</h2>
          </div>
          <div id="customize_area">
            <div id="customize_input">
              <div id="customize_input_area">
                <div id="customize_color" class="product_tab_content">
                  <div id="color-door-style" v-if="colorStyleList.length > 0">
                    <dd-color-style
                      ref="styleColorDoor"
                      :title="'扉/エンドパネル/カウンター'"
                      :styleList="colorStyleList"
                      :selectColorStyle="selectColorStyle"
                      @changeColorStyle="changeColorStyle"
                    />
                  </div>
                  <div id="color-door" v-if="doorColorList.length > 0">
                    <dd-color-pallet
                      ref="colorPalletDoor"
                      :documentId="'doorId'"
                      :title="doorColorTitle"
                      :colorList="doorColorList"
                      :color="colorDoor"
                      @selectColor="selectDoorColor"
                    />
                  </div>
                  <div id="color-cabine" v-if="cabineColorList.length > 0">
                    <dd-color-pallet
                      ref="colorPalletCabine"
                      :documentId="'cabineId'"
                      :title="'キャビネット/棚/脚カラーを選択ください'"
                      :colorList="cabineColorList"
                      :color="colorCabine"
                      @selectColor="selectCabineColor"
                    />
                  </div>
                  <div id="color-counter" v-if="counterColorList.length > 0">
                    <dd-color-pallet
                      ref="colorPalletCounter"
                      :documentId="'counterId'"
                      :title="'カウンターカラーを選択ください'"
                      :colorList="counterColorList"
                      :color="colorCounter"
                      @selectColor="selectCounterColor"
                    />
                  </div>
                </div>
                <div id="product_size" class="product_tab_content">
                  <div v-if="targetPlan.dcCategoryType==4">
                    <dd-param-size
                      ref="paramCommonRef"
                      :targetPlan="targetPlan"
                      :isDisableForm="isSpaceJoincd"
                      :isExecOrder="isExecOrder"
                      @changeWallFlag="changeWallFlag"
                    />
                  </div>
                  <div v-else-if="targetPlan.dcCategoryType==5">
                    <dd-param-size2
                      ref="paramCommonRef"
                      :targetPlan="targetPlan"
                      :isDisableForm="isSpaceJoincd"
                      :isExecOrder="isExecOrder"
                    />
                  </div>
                  <div v-else>
                    <dd-param-size-filler
                      ref="paramCommonRef"
                      :targetPlan="targetPlan"
                      :isDisableForm="isSpaceJoincd"
                      :isExecOrder="isExecOrder"
                      :isStruct="isResearch"
                      :categoryType="targetPlan.dcCategoryType"
                      :isExistEndPanel="isExistEndPanel"
                      :isMiura="isMiuraCompany"
                    />
                  </div>
                </div>
                <!-- <div id="reference_image" class="product_tab_content">
                  <div>
                    <h2>入力値参考画像</h2>
                  </div>
                  <p>寸法入力の際は、扉や引き出しがドア枠や照明・火災報知器などにあたらないか、搬入可能かどうか、ご確認の上、入力してください。</p>
                  <p>また設置壁面に対し5mm～10mmのクリアランスを考慮した寸法をご入力ください。</p>
                  <ul class="ul_tab small_text bold">
                    <li v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRef-' + index"
                      @click="tabType=inputRef.tabId" v-bind:class="{active: tabType==inputRef.tabId, tab_title: true}">{{inputRef.tabName}}</li>
                  </ul>
                  <div v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRefImage-' + index">
                    <div class="img_field" v-if="tabType==inputRef.tabId">
                      <img :src="getImage('top/item/input/' + inputRef.img)" width="100%" height="100%">
                    </div>
                  </div>
                </div> -->
                <div v-if="targetPlan.dcCategoryType==5" class="product_tab_content">
                  <h2>ご注文数を選択ください</h2>
                  <div class="content_line">
                    <label>ご注文数</label>
                    <input type="text" v-model="dcBoardCount" @keypress="validateNumber" @input="dcBoardCount=inputRestNumber($event)" @blur="onBlurOpBoardCount" maxlength="2">枚
                  </div>
                </div>
                <div id="customize_option" class="product_tab_content" v-else-if="targetPlan.dcCategoryType!==4 && !(targetPlan.opShelfType===1 && targetPlan.opFillerType===1)">
                  <h2>追加部材をご選択ください。</h2>
                  <div class="content_line" v-if="targetPlan.opShelfType!==1">
                    <input type="checkbox" :id="'opt_shelf'" v-model="isAddShelf" :disabled="targetPlan.opShelfType==2"/>
                    <label :for="'opt_shelf'">可動棚</label>
                    <input type="text" v-model="dcShelfCount" @keypress="validateNumber" @input="dcShelfCount=inputRestNumber($event)" @blur="onBlurOpShelfCount" maxlength="2" :disabled="!isAddShelf">
                    <label>枚/列</label>
                    <div>※列ごとに指定枚数追加されます。</div>
                  </div>
                  <div class="content_line" v-if="targetPlan.opFillerType!==1">
                    <input type="checkbox" :id="'opt_filler'" v-model="isAddFiller" :disabled="targetPlan.opFillerType==2"/>
                    <label :for="'opt_filler'">フィラー</label>
                    <input type="text" v-model="dcFillerCount" @keypress="validateNumber" @input="dcFillerCount=inputRestNumber($event)" @blur="onBlurOpFillerCount" maxlength="2" :disabled="!isAddFiller">
                    <label>本</label>
                    <div>※追加フィラーの寸法は、{{fillerSize}}mm×200mm×1800mmです。</div>
                  </div>
                </div>
                <div id="customize_construct" class="product_tab_content">
                  <div id="input_delivery">
                    <h2>納品先をご入力ください。</h2>
                    <div class="radio">
                      <input type="radio" :id="'delivery_exist_address'"  name="address" @change="changeNewInput()" :value="true" v-model="isExistDelivery"/>
                      <label :for="'delivery_exist_address'" class="radio-label bold">登録済みの郵便番号を選択する。</label>
                    </div>
                    <div class="content_line">
                      <div v-bind:class="{disable_form: !isExistDelivery}">
                        <select v-model="selBusiness" @change="changeNewInput()">
                          <option value='' class="select_placeholder">選択ください</option>
                          <option v-for="(del,index) in addressList" :key="'address-' + index" v-bind:value="del">{{del.businessName}}</option>
                        </select>
                      </div>
                      <div v-if="errors.selectList" class="error_text middle_text">{{errors.selectList}}</div>
                    </div>
                    <div class="radio">
                      <input type="radio" :id="'delivery_input_address'" name="address" @change="changeNewInput()" :value="false" v-model="isExistDelivery"/>
                      <label :for="'delivery_input_address'" class="radio-label bold">郵便番号を入力する。※郵便番号（半角数値、ハイフン不要）</label>
                    </div>
                    <div class="content_line">
                      <div v-bind:class="{disable_form: isExistDelivery}">
                        <input type="text" v-model="deliveryForm.postcd" @keypress="validateNumber" @input="deliveryForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" ><br>
                      </div>
                      <div v-if="errors.deliveryPostcd" class="error_text middle_text">{{errors.deliveryPostcd}}</div>
                    </div>
                  </div>
                  <div id="input_construct" v-if="targetPlan.dcCategoryType!==5">
                    <h2>組立設置の有無をご入力ください。</h2>
                    <div class="button01" id="construction" :disabled="!isSelectConstruct">
                      <input type="radio" name="construction_radio" id="construction_need" :class="{radio_need: isSelectConstruct, radio_need_disable: !isSelectConstruct}" value=1 v-model.number="workFlag" />
                      <label for="construction_need">あり</label>
                      <input type="radio" name="construction_radio" id="construction_no" :class="{radio_no: isSelectConstruct, radio_no_disable: !isSelectConstruct}" checked="" value=0 v-model.number="workFlag" />
                      <label for="construction_no">なし</label>
                    </div>
                    <div>※組立設置をご希望の場合、担当者よりご連絡いたします。</div>
                    <div class="customize_order" v-if="isConstruct">
                      <div class="radio">
                        <input type="radio" id="const_someaddress" name="struct_address" @change="changeNewStruct()" :value="true" v-model="isStructSameAddress"/>
                        <label :for="'const_someaddress'" class="radio-label bold">納品先と同じ住所</label>
                      </div>
                      <div class="radio">
                        <input type="radio" id="const_differ" name="struct_address" @change="changeNewStruct()" :value="false" v-model="isStructSameAddress"/>
                        <label :for="'const_differ'" class="radio-label bold">納品先住所と異なる住所の郵便番号（半角数値、ハイフン不要）</label>
                      </div>
                      <div class="content_line">
                        <!-- <div class="bold">※郵便番号（半角数値、ハイフン不要）</div> -->
                        <div v-bind:class="{disable_form: isStructSameAddress}">
                          <input type="text" v-model="constructForm.postcd" @keypress="validateNumber" @input="constructForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" ><br>
                        </div>
                        <div v-if="errors.constructPostcd" class="error_text middle_text">{{errors.constructPostcd}}</div>
                      </div>
                      <div class="customize_sub" v-if="isResearch && isCarry">
                        <div class="bold">受け取り搬入の有無をご入力ください。</div>
                        <!-- <div class="tooltip-parent">
                          <tool-tip ref="tooltipRef"
                            :img="imgQmark"
                            :messages="['ご注文いただいた収納家具をキャンディルテクトにて一旦お受け取りし、',
                              '後日、設置場所へ搬入いたします。']"
                            :posClass="'postop'"
                            :top="-80"
                            :left="-23"
                          />
                        </div> -->
                        <div class="button01" id="construction_op">
                          <input type="radio" name="construct_op_radio" id="construct_op_need" class="radio_need" value=1 v-model.number="constructOpFlag" />
                          <label for="construct_op_need">あり</label>
                          <input type="radio" name="construct_op_radio" id="construct_op_no" class="radio_no" checked="" value=0 v-model.number="constructOpFlag" />
                          <label for="construct_op_no">なし</label>
                        </div>
                      </div>
                      <div class="customize_sub">
                        <ul>
                          <li>組立設置オプションには以下の費用が発生します。</li>
                          <li>組立技術料：組立作業費および副資材、簡易養生材など。</li>
                          <li>諸経費：交通費、燃料代など。</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <!-- 6.事前現場調査の有無を選択 -->
                  <div class="form" v-if="isResearch">
                    <h2>事前現場調査の有無をご入力ください。</h2>
                    <div class="button01" id="resrch">
                      <input type="radio" name="resrch_radio" id="resrch_need" class="radio_need" value=1 v-model.number="resrchFlag" @change="changeResrch(1)"/>
                      <label for="resrch_need">あり</label>
                      <input type="radio" name="resrch_radio" id="resrch_no" class="radio_no" value=0 v-model.number="resrchFlag" @change="changeResrch(0)"/>
                      <label for="resrch_no">なし</label>
                    </div>
                    <div class="input_list" v-if="resrchFlag === 1">
                      <div class="customize_order">
                        <div class="radio">
                          <input type="radio" id="resrchSameAddress" name="clone" @change="changeResrchAdress()" :value="true" v-model="isResrchSameAddress">
                          <label for="resrchSameAddress" class="radio-label bold">納品先住所と同じ</label>
                        </div>
                        <div class="radio">
                          <input type="radio" id="resrchOtherAddress2" name="clone" @change="changeResrchAdress()" :value="false" v-model="isResrchSameAddress">
                          <label for="resrchOtherAddress2" class="radio-label bold">納品先と異なる場合</label>
                        </div>
                        <div class="content_line">
                          <div class="bold">※郵便番号（半角数値、ハイフン不要）</div>
                          <div v-bind:class="{disable_form: isResrchSameAddress===true}">
                            <input type="text" v-model="resrchForm.postcd" @keypress="validateNumber" @input="resrchForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" >
                          </div>
                          <div v-if="errors.resrchPostcd" class="error_text middle_text">{{errors.resrchPostcd}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="resrchFlag === 1" id="resrch_price_area">
              <div class="resrch_product_price">
                <div class="resrch_row">商品</div>
                <div>
                  <div>{{priceData.itemName}}</div>
                  <div>{{formatPrice(profitPrice(priceData.totalPrice))}}</div>
                </div>
                <div>
                  <div></div>
                  <div>事前現場調査後にご購入ください</div>
                </div>
              </div>
              <div class="resrch_price">
                <div>
                  <div>事前現場調査費</div>
                  <div>{{formatPrice(profitPrice(priceData.resrchPrice))}}</div>
                </div>
                <div>
                  <div>消費税(10%)</div>
                  <div>{{formatPrice(profitPrice(priceData.resrchPriceTax))}}</div>
                </div>
              </div>
            </div>
            <div id="product_price" v-else>
              <table class="top_price_table">
                <thead>
                  <tr>
                    <th class="order_th">項目</th>
                    <th class="order_th">単価</th>
                    <th class="order_th">数量</th>
                    <th class="order_th">単位</th>
                    <th class="order_th">金額</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="n_separator">
                    <td>{{priceData.itemName}}</td>
                    <td>{{formatPrice(profitPrice(priceData.itemPrice))}}</td>
                    <td>{{targetPlan.dcProductCount}}</td>
                    <td>台</td>
                    <td>{{formatPrice(profitPrice(priceData.itemPrice * targetPlan.dcProductCount))}}</td>
                  </tr>
                  <tr>
                    <td>配送料</td>
                    <td>{{formatPrice(profitPrice(priceData.delivaryPrice * targetPlan.dcProductCount))}}</td>
                    <td>1</td>
                    <td>式</td>
                    <td>{{formatPrice(profitPrice(priceData.delivaryPrice * targetPlan.dcProductCount))}}</td>
                  </tr>
                  <tr class="n_separator">
                    <td colspan="4">商品・配送費小計</td>
                    <td>{{formatPrice(profitPrice(priceData.subTotalPrice))}}</td>
                  </tr>
                </tbody>
              </table>
              <table class="top_price_table tbl_space" v-if="priceData.constructPrice">
                <tr class="n_separator">
                  <td>組立技術料</td>
                  <td>{{formatPrice(profitPrice(priceData.constructPrice * targetPlan.dcProductCount))}}</td>
                  <td>1</td>
                  <td>式</td>
                  <td>{{formatPrice(profitPrice(priceData.constructPrice * targetPlan.dcProductCount))}}</td>
                </tr>
                <tr v-if="priceData.carryInPrice">
                  <td>受け取り搬入サービス費</td>
                  <td>{{formatPrice(profitPrice(priceData.carryInPrice * targetPlan.dcProductCount))}}</td>
                  <td>1</td>
                  <td>式</td>
                  <td>{{formatPrice(profitPrice(priceData.carryInPrice * targetPlan.dcProductCount))}}</td>
                </tr>
                <tr>
                  <td>諸経費</td>
                  <td>{{formatPrice(profitPrice(priceData.executionVarExpensesPrice))}}</td>
                  <td>1</td>
                  <td>式</td>
                  <td>{{formatPrice(profitPrice(priceData.executionVarExpensesPrice))}}</td>
                </tr>
                <tr class="b_separator">
                  <td colspan="4">組立設置他サービス小計</td>
                  <td>{{formatPrice(profitPrice(priceData.optionSubTotalPrice))}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div id="product_order" class="n_separator">
            <div class="lds-sub-spinner" v-show="createPlanFlag===true">
              <div class="lds-spinner lds-spinner-pos">
                <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
              </div>
            </div>
            <div class="product_order_line">
              <img :src="imgCalc" class="icon_calc">
              <div class="bold">合計金額（税抜）</div>
              <div class="space"></div>
              <div class="price big_text2" v-if="resrchFlag">{{formatPrice(profitPrice(priceData.resrchTotalPrice))}}</div>
              <div class="price big_text2" v-else-if="!isPlanning">{{formatPrice(profitPrice(priceData.totalPrice))}}</div>
              <div class="price big_text2" v-else>{{priceCalcText}}</div>
            </div>
            <div class="product_order_line">
              <div id="order_cnt" v-if="targetPlan.dcCategoryType!==5 && !resrchFlag">
                <label>ご注文数</label>
                <input type="text" maxlength="2" id="product_cnt" v-model.number="targetPlan.dcProductCount" @keypress="validateNumber" @input="targetPlan.dcProductCount=inputRestNumber($event)" @blur="onBlurProductCount">
                <label>点</label>
              </div>
              <div class="space"></div>
              <div v-bind:class="{main_btn: true, act_sub_btn: true, disabled: !isExecOrder}" @click="onReEstimate()" v-on:mouseover="isOnReload(true)" v-on:mouseleave="isOnReload(false)">
                <img :src="imgReload" class="icon">
                <a>
                  <label>再計算</label>
                </a>
              </div>
              <div v-bind:class="{main_btn: true, act_main_btn: true, disabled: !isExecOrder}" @click="save()" v-on:mouseover="isOnSave(true)" v-on:mouseleave="isOnSave(false)">
                <img :src="imgSave" class="icon">
                <a>
                  <label>保存</label>
                </a>
              </div>
              <div v-bind:class="{main_btn: true, sel_main_btn: true, disabled: !isExecOrder}" @click="resrch()" v-if="resrchFlag">
                <a>
                  <label>事前現場調査見積り</label>
                </a>
              </div>
              <div v-bind:class="{main_btn: true, sel_main_btn: true, disabled: !isExecOrder}" @click="onShowEstimateModal()" v-else>
                <a>
                  <label>{{estimteBtnTitle}}</label>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import {mapActions, mapState} from 'vuex'

// common
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import * as Check from '../../utils/Check'

import Header from '../components/common/DcHeader'
import ColorStyle from '../components/top/input/color/DcColorStyle'
import ColorPallet from '../components/top/input/color/ColorPallet'
import ParamSize from '../components/top/input/paramater/ParamSize'
import ParamSize2 from '../components/top/input/paramater/ParamSize2'
import ParamSizeFiller from '../components/top/input/paramater/ParamSizeFiller'
import {PAYMENT_STATUS} from '../../constants/Type'
import {COLOR_MATERIAL_TYPE} from '../constants/TypeEc'
import {DC_URL, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import * as FormUtil from '../../utils/FormUtil'
import SwiperH from '../components/common/SwiperH'
import ToolTip from '../../components/common/ToolTip'
import LoadingModal from '../../components/common/LoadingModal'

// const
const CART_PRODUCT_MAX_COUNT = 30

export default {
  name: 'DcCustomize',
  components: {
    'dd-header': Header,
    'dd-color-style': ColorStyle,
    'dd-color-pallet': ColorPallet,
    'dd-param-size': ParamSize,
    'dd-param-size2': ParamSize2,
    'dd-param-size-filler': ParamSizeFiller,
    'dd-consturct': SwiperH,
    'tool-tip': ToolTip,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      // メインフォーム
      fileName: '',
      // dcFileDataList: [],
      // selOpenPlanData: {},
      // 空間情報
      spaceJoincd: '',
      // 1-1.収納スペース
      // targetPlan: {
      //   dcMinWidth: 0,
      //   dcMinHeight: 0,
      //   dcMinDepth: 0,
      //   dcMaxWidth: 0,
      //   dcMaxHeight: 0,
      //   dcMaxDepth: 0,
      //   dcProductCount: 1
      // },
      targetPlan: {
        corpData: {}
      },
      colorList: [],
      colorDoor: {},
      colorCabine: {},
      colorCounter: {},
      selectPostcd: {},
      isAddShelf: false,
      isAddFiller: false,
      dcShelfCount: 0,
      dcBoardCount: 1,
      dcFillerCount: 0,
      // 見積り関連
      businessDataList: [],
      businessId: '',
      selBusiness: {},
      saveForm: {},
      saveConstructForm: {},
      isExistDelivery: true,
      isStructSameAddress: true,
      deliveryForm: {
        id: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      constructForm: {
        id: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      resrchForm: {
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      copyForm: {},
      priceData: {},
      // commonList: [],
      constructList: [],
      isOrder: false,
      workFlag: 0,
      constructOpFlag: 0,
      resrchFlag: 0,
      leftSide: '',
      rightSide: '',
      isCounter: false,
      // エラー
      errors: {},
      // フィラー・エンドパネルの設定
      isLeftFilter: false,
      isLeftEndPanel: false,
      isRightFilter: false,
      isRightEndPanel: false,
      // tabType: 1,
      isResrchSameAddress: true,
      label: {
        postcd: '郵便番号'
      },
      userInfo: {},
      planListOptions: {
        slidesPerGroup: 1,
        slidesPerView: 1,
        initialSlide: 0,
        slidesPerColumn: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true
        // spaceBetween: 5
      },
      buyFlag: false,
      updateFlag: false,
      saveFlag: false,
      estimateFlag: false,
      doResrchFlag: false,
      imgQmark: App.getMmstyleResource('common/qmark_gray.svg'),
      createPlanFlag: false,
      runPlanList: [],
      priceCalcText: '計算中',
      priceCalcTimer: undefined,
      deliErrMessage: ['恐れ入りますが、ご入力いただいた地域への配送は別途の調整となります。',
        '画面上部「お問い合わせ」より、ご希望の商品と納品先のご住所をご連絡ください。',
        '　',
        '納品先調整地域：北海道全域、沖縄全域、四国一部地域、離島など一部地域。',
        '組立設置先：制限なし(全国対応)'
      ],
      isWallEmbedded: false,
      constructOptions: {
        slidesPerView: 'auto',
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0
      },
      selectManual: {},
      manualList: [
        {id: 1, name: '基本仕様'},
        {id: 2, name: '金属・部品仕様'},
        {id: 3, name: '扉カラー'}
      ],
      isMenuActive: false,
      // PDF
      manual: {
        action: '/dl_manual',
        dlFileName: '取扱説明書.pdf',
        fileName: 'file.manual'
      },
      setupManual: {
        action: '/dl_set_up_manual',
        dlFileName: '設置説明書.pdf',
        fileName: 'file.setup.manual'
      },
      // カラースタイル
      colorStyleList: [],
      selectColorStyle: {},
      categoryType: 0,
      imgReload: this.getImage('common/reload_black.svg'),
      imgSave: this.getImage('common/save_orange.svg'),
      imgCalc: this.getImage('common/calculator.svg')
    }
  },
  methods: {
    ...mapActions({ getCartData: 'loadCartData' }),
    defaultPlan: async function (id) {
      let param = {
        dcFdId: this.targetPlan.dcFdId
      }
      // this.selectPublicPlan(this.targetPlan.dcFdId)
      await this.selectPlan(param)
      await this.createPlan(this.topForm)
    },
    readSaveParam: async function (id, param) {
      // await this.init(id)
      // this.selectPublicPlan(param.dcFdId)
      await this.selectPlan(param)
      await this.setSaveParam(param)
      await this.createPlan(this.topForm)
    },
    // selectSwipePlan: function (obj) {
    //   let selPlan = this.dcFileDataList.find(p => p.dcFdId === obj.id)
    //   this.selectPublicPlan(obj.id)
    //   this.selectPlan(selPlan)
    // },
    // 公開プランの選択、ローカルプランの作成
    selectPlan: async function (param) {
      console.log('select plan start')
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        params: {
          dcFdId: param.dcFdId
        }
      }
      // this.targetPlan = Object.assign({}, this.selOpenPlanData)

      await axios.get(DC_URL.TOP + '/select', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.selectedPlan(response.data.data)
            console.log('select end')
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          console.log('select finally')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    setSaveParam: async function (param) {
      console.log('setSaveParam start')
      let targetPlan = this.targetPlan
      this.$set(targetPlan, 'dcWidth', param.dcWidth)
      this.$set(targetPlan, 'dcHeight', param.dcHeight)
      this.$set(targetPlan, 'dcHeight2', param.dcHeight2)
      this.$set(targetPlan, 'dcDepth', param.dcDepth)
      this.$set(targetPlan, 'dcDepth2', param.dcDepth2)
      this.$set(targetPlan, 'dcBSize', param.dcBSize)
      this.$set(targetPlan, 'dcCSize', param.dcCSize)
      this.$set(targetPlan, 'dcDSize', param.dcDSize)
      this.$set(targetPlan, 'dcBType', param.dcBType)
      this.$set(targetPlan, 'dcCType', param.dcCType)
      this.$set(targetPlan, 'dcDType', param.dcDType)
      this.targetPlan = Object.assign({}, targetPlan)
      // 初期カラー選択
      this.$nextTick(function () {
        if (param.dcColorDoorDetail) {
          this.selectDoorColor(param.dcColorDoorDetail)
        } else {
          this.selectDoorColor(null)
        }
        if (param.dcColorBoxDetail) {
          this.selectCabineColor(param.dcColorBoxDetail)
        } else {
          this.selectCabineColor(null)
        }
        if (param.dcColorCounterDetail) {
          this.selectCounterColor(param.dcColorCounterDetail)
        } else {
          this.selectCounterColor(null)
        }
        console.log('selectedPlan end color')
      })
      // 追加可動棚の設定
      if (param.dcShelfCount && param.dcShelfCount > 0) {
        this.isAddShelf = true
        this.dcShelfCount = param.dcShelfCount
      } else {
        this.isAddShelf = false
      }
      if (param.dcFillerCount && param.dcFillerCount > 0) {
        this.isAddFiller = true
        this.dcFillerCount = param.dcFillerCount
      } else {
        this.isAddFiller = false
      }
      // 納品先のみ込み
      if (!Check.isNullOrUndefined(param.businessId)) {
        // 納品先読み込み
        this.isExistDelivery = param.dcSaveExistDeliFlag
        let business = this.addressList.find(a => a.businessId === param.businessId)
        if (business !== undefined) {
          this.selBusiness = business
          this.$set(this.deliveryForm, 'postcd', param.dcSaveDeliPostcd)
        } else {
          // 削除済み
          this.selBusiness = {}
        }
      } else {
        // 入力
        this.isExistDelivery = false
        this.$set(this.deliveryForm, 'postcd', param.dcSaveDeliPostcd)
      }
      // 組立施工読み込み
      this.workFlag = param.dcWorkFlag ? 1 : 0
      this.isStructSameAddress = param.dcStructSameAddressFlag
      this.$set(this.constructForm, 'postcd', param.dcStructPostcd)
      this.constructOpFlag = param.dcConstructOpServiceFlag ? 1 : 0
      // 事前現場調査読み込み
      this.resrchFlag = param.dcSaveResrchFlag ? 1 : 0
      this.$set(this.resrchForm, 'postcd', param.dcSaveResrchPostcd)
      this.isResrchSameAddress = param.dcSaveSameAddressFlag

      // 棚板のご注文数を保持
      if (param.categoryId === 5) {
        this.dcBoardCount = param.dcShelfCount ? param.dcShelfCount : 0
      } else {
        this.$set(this.targetPlan, 'dcProductCount', param.dcProductCount)
      }
      console.log('setSaveParam end')
    },
    // セットプラン選択後のクライアント側の対応
    selectedPlan: function (data) {
      console.log('start selectedPlan')
      this.targetPlan = Object.assign({}, this.convertDcFileData(data.dcFileData))
      // カラースタイルを設定
      this.colorStyleList = []
      data.colorStyleList
        .forEach(e => {
          let style = {
            colorStyleId: e.colorStyleId,
            corpId: e.corpId,
            colorTypeNo: e.colorTypeNo,
            colorStyleNo: e.colorStyleNo,
            colorStyleName: e.colorStyleName,
            colorStyleImage: this.getImage('style/' + e.colorStyleImage)
          }
          this.colorStyleList.push(style)
        })
      // 初期カラースタイル選択
      if (this.colorStyleList.length > 0) {
        this.selectColorStyle = this.colorStyleList[0]
      } else {
        this.selectColorStyle = {}
      }
      // カラーリストを設定
      this.colorList = []
      data.dcColorList
        .forEach(e => {
          let color = {
            id: e.no,
            name: e.name,
            type: e.type,
            style: e.colorStyleNo,
            no: e.dispNo,
            img: this.getImage('color/' + e.img),
            imgB: this.getImage('color/' + this.bigImage(e.img))
          }
          this.colorList.push(color)
        })
      // 初期カラー選択
      this.$nextTick(function () {
        if (this.doorColorList.length > 0) {
          let color = this.doorColorList.find(c => c.id === data.dcParamModel.dcColorDoor)
          this.selectDoorColor(color !== undefined ? color : this.doorColorList[0])
        } else {
          this.selectDoorColor(null)
        }
        if (this.cabineColorList.length > 0) {
          let color = this.cabineColorList.find(c => c.id === data.dcParamModel.dcColorBox)
          this.selectCabineColor(color !== undefined ? color : this.cabineColorList[0])
        } else {
          this.selectCabineColor(null)
        }
        if (this.counterColorList.length > 0) {
          let color = this.counterColorList.find(c => c.id === data.dcParamModel.dcColorCounter)
          this.selectCounterColor(color !== undefined ? color : this.counterColorList[0])
        } else {
          this.selectCounterColor(null)
        }
        console.log('selectedPlan end color')
      })
      // 追加可動棚の設定
      if (data.dcParamModel.dcShelfCount && data.dcParamModel.dcShelfCount > 0) {
        this.isAddShelf = true
        this.dcShelfCount = data.dcParamModel.dcShelfCount
      } else {
        this.isAddShelf = false
      }
      if (data.dcParamModel.dcFillerCount && data.dcParamModel.dcFillerCount > 0) {
        this.isAddFiller = true
        this.dcFillerCount = data.dcParamModel.dcFillerCount
      } else {
        this.isAddFiller = false
      }
      // this.commonList = data.commonList
      // 組立設置例の設定
      this.constructList = []
      data.constructList
        .forEach(c => {
          let construct = {
            id: c.id,
            dcFdId: c.dcFdId,
            price: c.price,
            img: this.getImage('top/construct/' + c.img),
            imgB: this.getImage('top/construct/' + this.bigImage(c.img))
          }
          this.constructList.push(construct)
        })
      console.log('end selectedPlan')
    },
    createPlan: function (param) {
      let payload = Object.assign({}, param)
      console.log('start create ' + param.dcFdId)
      this.createPlanFlag = true
      axios.post(DC_URL.TOP + '/create', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            console.log('ret create ' + param.dcFdId)
            this.spaceJoincd = response.data.data.spaceJoincd
            this.priceData = response.data.data.priceData
            this.clearPriceCalcTimer()
            // this.nextPlan()
            this.createPlanFlag = false
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          console.log('end create ' + param.dcFdId)
        })
      // }
    },
    // nextPlan: function () {
    //   if (this.runPlanList.length === 0) {
    //     console.log('run plan list zero')
    //     this.createPlanFlag = false
    //     return
    //   }
    //   console.log('next plan ' + this.runPlanList[this.runPlanList.length - 1])
    //   this.createPlan(this.runPlanList[this.runPlanList.length - 1])
    //   this.runPlanList = []
    // },
    onReEstimate: async function () {
      try {
        console.log('do update1')
        if (this.updateFlag) return
        console.log('do update2')
        this.updateFlag = true
        this.$refs.loadingModalRef.showModal(true)
        // await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
        await this.postcdCompleteDelivery()
        await this.postcdCompleteStruct()
        await this.postcdCompleteResrch()
        if (!this.checkInputParam()) {
          console.log('Failed to check input parameters')
          return
        }
        await this.update()
      } catch (error) {
        console.log('doupdate cacth')
      } finally {
        console.log('doupdate finally')
        this.updateFlag = false
        this.$refs.loadingModalRef.showModal(false)
      }
    },
    // ローカルプランの更新
    update: async function () {
      console.log('update')
      let payload = this.topForm
      await axios.post(DC_URL.TOP + '/update', payload
      )
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // 金額とファイルを更新
            this.priceData = response.data.data.priceData
            this.spaceJoincd = response.data.data.spaceJoincd
          }
        }).catch(error => {
          Api.handleError(error)
        })
    },
    save: async function () {
      if (this.saveFlag) return
      this.saveFlag = true
      // this.$refs.loadingModalRef.showModal(true)
      // await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      await this.postcdCompleteResrch()
      if (!this.checkInputParam()) {
        console.log('Failed to check input parameters')
        this.saveFlag = false
        // this.$refs.loadingModalRef.showModal(false)
        return
      }
      let modalData = {
        title: '',
        messages: ['保存名を入力してください。'],
        modalType: 'confirm',
        textAlign: 'center',
        okBtnLabel: '保存',
        callbackParams: {},
        onOk: (callback) => {
          let payload = this.topForm
          this.$set(payload, 'saveName', callback.saveName)
          this.$refs.loadingModalRef.showModal(true)
          axios.post(DC_URL.SAVE, payload
          ).then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
              this.$refs.loadingModalRef.showModal(false)
            } else {
              console.log('show save dialog')
              App.showModal({
                title: '',
                messages: ['商品情報が保存されました'],
                messageType: 'success',
                layoutType: 'layout-classic',
                modalType: 'confirm',
                textAlign: 'center',
                okBtnLabel: '閉じる',
                cancelBtnLabel: '保存リスト',
                onOk: () => {
                  // 特になし
                  console.log('save dialog click ok button')
                },
                onCancel: () => {
                  this.$router.push({
                    name: 'SaveItemList'
                  })
                }
              })
            }
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
            App.showModal({
              title: 'システムエラー',
              messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
              messageType: 'error',
              textAlign: 'left'
            })
          }).finally(() => {
            console.log('save finally')
            this.$refs.loadingModalRef.showModal(false)
          })
        }
      }
      AppEc.showProductSave(modalData)
      this.saveFlag = false
    },
    // 見積り・図面ダイアログを表示
    onShowEstimateModal: async function () {
      console.log('run planning data. ' + this.runPlanList.length)
      console.log('create plan flag. ' + this.createPlanFlag)
      // 多重防止
      if (this.estimateFlag) return
      this.estimateFlag = true
      this.$refs.loadingModalRef.showModal(true)
      // await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct()])
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      await this.postcdCompleteResrch()
      // チェック処理
      if (!this.checkInputParam()) {
        this.$refs.loadingModalRef.showModal(false)
        this.estimateFlag = false
        return
      }
      // 画面データを渡す
      let payload = this.topForm
      axios.post(DC_URL.TOP + '/order', payload
      )
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
          } else {
            // 金額とファイルを更新
            this.priceData = response.data.data.priceData
            this.spaceJoincd = response.data.data.spaceJoincd
            // ダイアログ表示
            let modalData = {
              onOk: () => {
                this.buy(response.data.data.constructOpAddressData)
              },
              showSuccess: () => {
                this.$refs.loadingModalRef.showModal(false)
              },
              fileName: this.fileName,
              titleDoor: '扉カラー',
              colorDoor: this.colorDoor,
              titleCabine: 'キャビネット/棚/脚カラー',
              colorCabine: this.colorCabine,
              titleCounter: 'カウンターカラー',
              colorCounter: this.colorCounter,
              priceData: this.priceData,
              spaceJoincd: this.spaceJoincd,
              dispOrderButton: true,
              dcProductCount: Number(this.targetPlan.dcProductCount),
              isCalcDelivery: true,
              isDrawing: this.targetPlan.dcCategoryType !== 5,
              corpData: this.targetPlan.corpData,
              isProfitFlag: true,
              isProductData: true
            }
            AppEc.showEstimateModal(modalData)
            this.estimateFlag = false
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
          this.$refs.loadingModalRef.showModal(false)
          App.showModal({
            title: 'システムエラー',
            messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
            messageType: 'error',
            textAlign: 'left'
          })
        }).finally(() => {
          this.estimateFlag = false
        })
    },
    buy: function () {
      if (this.nowList.length >= CART_PRODUCT_MAX_COUNT) {
        App.showModal({
          messages: ['カートに追加できる商品は' + CART_PRODUCT_MAX_COUNT + '個までになります。']
        })
        return
      }
      // 多重防止
      if (this.buyFlag) return
      this.buyFlag = true
      App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
      App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
      App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
      if (this.isExistDelivery) {
        App.setLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS, this.selBusiness)
      }
      App.setLocalStorage(DC_STORAGE_KEY.TOP_FORM, this.topForm)
      App.setLocalStorage(DC_STORAGE_KEY.FILE_NAME, this.fileName)
      this.addCart()
    },
    // selectPublicPlan: function (dcFdId) {
    //   if (!this.dcFileDataList || this.dcFileDataList.length <= 0) {
    //     console.log('called without public plan')
    //   }
    //   this.selOpenPlanData = this.dcFileDataList.find(e => e.dcFdId === dcFdId)
    //   this.targetPlan = Object.assign({}, this.selOpenPlanData)
    // },
    // 入力チェック
    postcdCompleteDelivery: async function () {
      console.log('do postcdCompleteDelivery1')
      await FormUtil.addressCompletion(this.deliveryForm.postcd, (address) => {
        this.$set(this.deliveryForm, 'state', address.state)
        this.$set(this.deliveryForm, 'city', address.city)
        this.$set(this.deliveryForm, 'street', address.street)
        // チェック処理
        console.log('do postcdCompleteDelivery2')
      })
    },
    postcdCompleteStruct: async function () {
      console.log('do postcdCompleteStruct1')
      if (!this.workFlag) return
      let postcd = this.constructForm.postcd
      if (this.isStructSameAddress) {
        postcd = this.deliveryForm.postcd
      }
      await FormUtil.addressCompletion(postcd, (address) => {
        this.$set(this.constructForm, 'state', address.state)
        this.$set(this.constructForm, 'city', address.city)
        this.$set(this.constructForm, 'street', address.street)
        // チェック処理
        console.log('do postcdCompleteStruct2')
      })
    },
    postcdCompleteResrch: async function () {
      // 配送不可チェック
      if (!this.resrchFlag) return
      let postcd = this.resrchForm.postcd
      if (this.isResrchSameAddress) {
        postcd = this.deliveryForm.postcd
      }
      await FormUtil.addressCompletion(postcd, (address) => {
        this.$set(this.resrchForm, 'state', address.state)
        this.$set(this.resrchForm, 'city', address.city)
        this.$set(this.resrchForm, 'street', address.street)
      })
    },
    checkInputParam: function () {
      console.log('check input param')
      // 入力チェック
      this.errors = {}
      // 配送不可チェック
      if (!this.validateDeliImpossiblePostCd(this.deliveryForm.postcd, this.deliErrMessage)) {
        console.log('delivery postcd is impossible.')
        return false
      }
      let isCheckParam = this.$refs.paramCommonRef.checkParam()
      this.validateProductCnt()
      this.validateColor()
      this.validateRequireDeliveryPostcd()
      if (this.isConstruct) {
        this.validateRequireConstructPostcd()
      }
      if (this.resrchFlag) {
        this.validateRequireResrchPostcd()
      }
      if (Object.keys(this.errors).length !== 0 || !isCheckParam) {
        this.showErrorInput()
        return false
      }
      return true
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    convertHalfNumber: function (event) {
      // 郵便番号や電話番号で最初に0がくる場合があるため別で用意
      let str = FormUtil.restHalfNumber(event.target.value)
      return str
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    validateProductCnt: function () {
      let ret = true
      if (!Check.isNumber(this.targetPlan.dcProductCount)) {
        this.errors['product'] = 'ご注文数は数値で入力してください。'
        ret = false
      } else {
        delete this.errors.product
        ret = true
      }
      this.$forceUpdate()
      return ret
    },
    validateColor: function () {
      let ret = true
      if (!this.colorDoor && !this.colorCabine && !this.colorCounter) {
        this.errors['Color'] = 'カラーが選択されていません。'
        ret = false
      } else {
        delete this.errors.Color
      }
      this.$forceUpdate()
      return ret
    },
    validateRequireDeliveryPostcd: function () {
      let ret = true
      // 登録済みを選択して、保存リストを選択していなかった場合
      if (this.isExistDelivery && Object.keys(this.selBusiness).length === 0) {
        this.errors['selectList'] = '項目を選択してください'
        ret = false
      } else if (!this.deliveryForm.postcd && this.deliveryForm.postcd.length <= 0) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'は必須項目です'
        ret = false
      } else if (!Check.isPostCd(this.deliveryForm.postcd)) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
        ret = false
      } else if (!FormUtil.isExistPostcd(this.deliveryForm.postcd)) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'が存在しません。'
        ret = false
      } else if (this.deliveryForm.postcd.length > 0 && (!this.deliveryForm.state || !this.deliveryForm.city || !this.deliveryForm.street)) {
        this.errors['deliveryPostcd'] = this.label.postcd + 'が間違っています'
        return false
      } else {
        delete this.errors.deliveryPostcd
      }
      this.$forceUpdate()
      return ret
    },
    validateRequireConstructPostcd: function () {
      let ret = true
      // 登録済みを選択して、保存リストを選択していなかった場合
      if (!this.isStructSameAddress) {
        if (!this.constructForm.postcd && this.constructForm.postcd.length <= 0) {
          this.errors['constructPostcd'] = this.label.postcd + 'は必須項目です'
          ret = false
        } else if (!Check.isPostCd(this.constructForm.postcd)) {
          this.errors['constructPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
          ret = false
        } else if (!FormUtil.isExistPostcd(this.constructForm.postcd)) {
          this.errors['constructPostcd'] = this.label.postcd + 'が存在しません。'
          ret = false
        } else if (this.constructForm.postcd.length > 0 && (!this.constructForm.state || !this.constructForm.city || !this.constructForm.street)) {
          this.errors['constructPostcd'] = this.label.postcd + 'が間違っています'
          return false
        } else {
          delete this.errors.constructPostcd
        }
      }
      this.$forceUpdate()
      return ret
    },
    validateRequireResrchPostcd: function () {
      let ret = true
      // 登録済みを選択して、保存リストを選択していなかった場合
      if (!this.isResrchSameAddress) {
        if (!this.resrchForm.postcd && this.resrchForm.postcd.length <= 0) {
          this.errors['resrchPostcd'] = this.label.postcd + 'は必須項目です'
          ret = false
        } else if (!Check.isPostCd(this.resrchForm.postcd)) {
          this.errors['resrchPostcd'] = this.label.postcd + 'は半角数値7桁で入力してください。'
          ret = false
        } else if (!FormUtil.isExistPostcd(this.resrchForm.postcd)) {
          this.errors['resrchPostcd'] = this.label.postcd + 'が存在しません。'
          ret = false
        } else if (this.resrchForm.postcd.length > 0 && (!this.resrchForm.state || !this.resrchForm.city || !this.resrchForm.street)) {
          this.errors['resrchPostcd'] = this.label.postcd + 'が間違っています'
          return false
        } else {
          delete this.errors.resrchPostcd
        }
      }
      this.$forceUpdate()
      return ret
    },
    validateDeliImpossiblePostCd: function (postcd, message) {
      if (!Check.checkDeliImposible(postcd)) {
        App.showModal({
          messages: message,
          onCancel: this.newTabSupport,
          modalType: 'confirm',
          okBtnLabel: 'キャンセル',
          cancelBtnLabel: 'お問い合わせ',
          layoutType: 'classic',
          textAlign: 'left'
        })
        return false
      }
      return true
    },
    // 商品寸法
    onBlurOpShelfCount: function () {
      if (!this.dcShelfCount || this.dcShelfCount <= 0) {
        this.dcShelfCount = 0
      }
    },
    onBlurOpBoardCount: function () {
      if (!this.dcBoardCount || this.dcBoardCount <= 0) {
        this.dcBoardCount = 1
      }
    },
    onBlurOpFillerCount: function () {
      if (!this.dcFillerCount || this.dcFillerCount <= 0) {
        this.dcFillerCount = 0
      }
    },
    onBlurProductCount: function () {
      if (!this.targetPlan.dcProductCount || this.targetPlan.dcProductCount <= 0) {
        this.targetPlan.dcProductCount = 0
      }
    },
    // カラー
    selectDoorColor: function (color) {
      this.colorDoor = color
    },
    selectCabineColor: function (color) {
      this.colorCabine = color
    },
    selectCounterColor: function (color) {
      this.colorCounter = color
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    getContents: function (content) {
      return App.getMmstyleContents(content)
    },
    // 注文
    addCart: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(DC_URL.TOP + '/buy')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
          } else {
            this.$store.dispatch('loadCartData')
            App.showModal({
              title: '',
              messages: ['商品がカートに追加されました。'],
              messageType: 'success',
              layoutType: 'layout-classic',
              modalType: 'confirm',
              textAlign: 'center',
              okBtnLabel: '閉じる',
              cancelBtnLabel: 'カートを見る',
              onOk: () => {
                // 特になし
              },
              onCancel: () => {
                this.$router.push({
                  name: 'Cart'
                })
              }
            })
            this.$refs.loadingModalRef.showModal(false)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
          App.showModal({
            title: 'システムエラー',
            messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
            messageType: 'error',
            textAlign: 'left'
          })
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.buyFlag = false
        })
    },
    resrch: async function () {
      // 多重防止
      if (this.doResrchFlag) return
      this.doResrchFlag = true
      this.errors = {}
      this.$refs.loadingModalRef.showModal(true)
      // await Promise.all([this.postcdCompleteDelivery(), this.postcdCompleteStruct(), this.postcdCompleteResrch()])
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      await this.postcdCompleteResrch()
      // チェック処理
      if (!this.checkInputParam()) {
        this.doResrchFlag = false
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      // 画面データを渡す
      let payload = this.topForm
      axios.post(DC_URL.TOP + '/order', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
          this.$refs.loadingModalRef.showModal(false)
        } else {
          App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
          App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
          App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
          App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
          // 金額とファイルを更新
          this.priceData = response.data.data.priceData
          this.spaceJoincd = response.data.data.spaceJoincd
          // ダイアログ表示
          let modalData = {
            onOk: () => {
              let topForm = {
                categoryId: this.targetPlan.dcCategoryType,
                topSpace: this.targetPlan,
                titleDoor: '扉カラー',
                colorDoor: this.colorDoor,
                titleCabine: 'キャビネット/棚/脚カラー',
                colorCabine: this.colorCabine,
                titleCounter: 'カウンターカラー',
                colorCounter: this.colorCounter,
                dcWorkFlag: this.isConstruct,
                isLeftFiller: this.isLeftFiller,
                isRightFiller: this.isRightFiller,
                dcShelfCount: this.opShelfCount,
                dcFillerCount: this.isAddFiller ? this.dcFillerCount : 0,
                spaceJoincd: this.spaceJoincd,
                dcProductCount: this.targetPlan.dcProductCount,
                pageList: this.getPageList,
                postcd: this.resrchForm.postcd,
                state: this.resrchForm.state,
                city: this.resrchForm.city,
                street: this.resrchForm.street,
                resrchFlag: this.resrchFlag
              }
              App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
              App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
              if (this.isExistDelivery && this.isResrchSameAddress) {
                App.setLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS, this.selBusiness)
              }
              App.setLocalStorage(DC_STORAGE_KEY.TOP_FORM, topForm)
              App.setLocalStorage(DC_STORAGE_KEY.PRICE_DATA, this.priceData)
              App.setLocalStorage(DC_STORAGE_KEY.FILE_NAME, this.fileName)
              this.$router.push({
                name: 'BuildingResearchBusiness'
              })
            },
            showSuccess: () => {
              this.$refs.loadingModalRef.showModal(false)
            },
            fileName: this.fileName,
            titleDoor: '扉カラー',
            colorDoor: this.colorDoor,
            titleCabine: 'キャビネット/棚/脚カラー',
            colorCabine: this.colorCabine,
            titleCounter: 'カウンターカラー',
            colorCounter: this.colorCounter,
            priceData: this.priceData,
            spaceJoincd: this.spaceJoincd,
            dispOrderButton: true,
            dcProductCount: Number(this.targetPlan.dcProductCount),
            isCalcDelivery: true,
            isDrawing: this.targetPlan.dcCategoryType !== 5,
            corpData: this.targetPlan.corpData,
            isProfitFlag: true,
            isProductData: true,
            resrchFlag: this.resrchFlag === 1
          }
          AppEc.showEstimateModal(modalData)
          this.doResrchFlag = false
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        App.showModal({
          title: 'システムエラー',
          messages: ['何らかの理由で不具合が発生しました。\nもう一度ページを開き直しても正しく表示されない時は、しばらく時間をおいてからお試しください。'],
          messageType: 'error',
          textAlign: 'left'
        })
        this.$refs.loadingModalRef.showModal(false)
        this.doResrchFlag = false
      }).finally(() => {
      })
    },
    profitPrice: function (price) {
      if (!price || !this.priceData) return
      return (Math.ceil(price / this.priceData.profitProb))
    },
    // 見積りダイアログ系
    doorColorContentNo: function () {
      if (this.doorColorList.length > 0) {
        return 1
      }
    },
    boxColorContentNo: function () {
      if (this.doorColorList.length > 0 && this.cabineColorList.length > 0) {
        return 2
      } else if (this.cabineColorList.length > 0) {
        return 1
      }
    },
    counterColorContentNo: function () {
      if (this.doorColorList.length > 0 && this.cabineColorList.length > 0 && this.counterColorList.length > 0) {
        return 3
      } else if ((this.doorColorList.length > 0 || this.cabineColorList.length > 0) && this.counterColorList.length > 0) {
        return 2
      } else {
        return 1
      }
    },
    // titleDoor: function () {
    //   if (this.colorDoor != null) {
    //     return '扉カラー'
    //   }
    //   return ''
    // },
    // titleCabine: function () {
    //   if (this.colorDoor != null && this.colorCabine != null) {
    //     return '4.キャビネット/棚/脚カラー'
    //   } else if (this.colorCabine != null) {
    //     return '3.キャビネット/棚/脚カラー'
    //   }
    //   return ''
    // },
    // titleCounter: function () {
    //   if (this.colorCounter == null) {
    //     return ''
    //   }
    //   if (this.colorDoor != null && this.colorCabine != null) {
    //     return '5.カウンターカラー'
    //   } else if (this.colorDoor != null || this.colorCabine != null) {
    //     return '4.カウンターカラー'
    //   }
    //   return '3.カウンターカラー'
    // },
    // システム系
    setPriceCalcTimer: function () {
      if (this.priceCalcTimer) return
      let _this = this
      this.priceCalcTimer = function () {
        _this.priceCalcText = _this.priceCalcText.replace('...', '') + '.'
      }
      setInterval(this.priceCalcTimer, 1000)
    },
    clearPriceCalcTimer: function () {
      clearInterval(this.priceCalcTimer)
    },
    changeWallFlag: function (flg) {
      this.isWallEmbedded = flg
    },
    newTabSupport: function () {
      let newWindow = window.open('/#/mmstyle/support/input', 'support')
      newWindow.location.reload()
    },
    showErrorInput: function () {
      App.showModal({
        messages: ['入力内容を確認してください。'],
        onOk: this.onNew
      })
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    sizeName: function (w, h, d) {
      if (!w || !h || !d) return ''
      return w + '×' + h + '×' + d + '(mm)'
    },
    productSize: function (min, max) {
      return (min + ' ≦ W ≦ ' + max)
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    },
    changeResrchAdress: function () {
      if (this.isResrchSameAddress) {
        this.copyForm = Object.assign({}, this.resrchForm)
        this.$set(this.resrchForm, 'postcd', this.deliveryForm.postcd)
      } else {
        this.resrchForm = Object.assign(this.resrchForm, this.copyForm)
      }
    },
    changeNewInput: function () {
      delete this.errors.selectList
      delete this.errors.deliveryPostcd
      if (this.isExistDelivery) {
        // 新規から既存に切り替わったとき
        // 新規で入力していた値を一時退避
        this.saveForm = Object.assign({}, this.deliveryForm)
        if (this.selBusiness) {
          this.$set(this.deliveryForm, 'postcd', this.selBusiness.postcd)
        }
      } else {
        // 既存から新規に切り替わったとき
        if (Object.keys(this.saveForm).length > 0) {
          // 新規で入力していたら退避していた値を戻す
          this.deliveryForm = Object.assign({}, this.saveForm)
        } else {
          this.$set(this.deliveryForm, 'postcd', '')
        }
      }
    },
    changeNewStruct: function () {
      delete this.errors.constructPostcd
      if (!this.isStructSameAddress) {
        // 既存から新規に切り替わったとき
        if (Object.keys(this.saveConstructForm).length > 0) {
          // 新規で入力していたら退避していた値を戻す
          this.constructForm = Object.assign({}, this.saveConstructForm)
        } else {
          this.$set(this.constructForm, 'postcd', '')
        }
      } else {
        // 新規から既存に切り替わったとき
        // 新規で入力していた値を一時退避
        this.saveConstructForm = Object.assign({}, this.constructForm)
        this.$set(this.constructForm, 'postcd', this.deliveryForm.postcd)
      }
    },
    changeResrch: function (status) {
      if (status === 1) {
        delete this.errors.selectList
        delete this.errors.deliveryPostcd
      } else {
        delete this.errors.resrchPostcd
      }
      this.$forceUpdate()
    },
    // previewManual: function (manual) {
    //   let imageList = [
    //     this.getImage('top/item/input/BSA_filler_off.png'),
    //     this.getImage('top/item/input/BSA_filler_on.png'),
    //     this.getImage('top/item/input/BSA_filler_off.png'),
    //     this.getImage('top/item/input/BSA_filler_on.png'),
    //     this.getImage('top/item/input/BSA_filler_off.png'),
    //     this.getImage('top/item/input/BSA_filler_on.png'),
    //     this.getImage('top/item/input/BSA_filler_off.png'),
    //     this.getImage('top/item/input/BSA_filler_on.png')
    //   ]
    //   let modalData = {
    //     imageList: imageList,
    //     swiperOptions: this.constructOptions
    //   }
    //   AppEc.showImageSlideModal(modalData)
    // },
    onMenu: function () {
      if (this.isMenuActive) {
        this.isMenuActive = false
      } else {
        this.isMenuActive = true
      }
    },
    downloadManual: function (fileName) {
      let link = document.createElement('a')
      link.href = this.getContents(fileName)
      window.open(link)
    },
    goCategory: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    categoryImgBlack: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    previewConstruct: function (img) {
      let modalData = {
        image: img
      }
      AppEc.showImageViewerModal(modalData)
    },
    convertDcFileData: function (data) {
      let dcFileData = {
        dcFdId: data.dcFdId,
        dcCategoryType: data.dcCategoryType,
        dcFdName: data.dcFdName,
        dcFileName: data.dcFileName,
        seriesName: data.seriesName,
        dcFdImage: data.dcFdImage,
        dcFdImageB: this.bigImage(data.dcFdImage),
        dcWidth: data.defW,
        dcMinWidth: data.minW,
        dcMaxWidth: data.maxW,
        dcHeight: data.defH,
        dcMinHeight: data.minH,
        dcMaxHeight: data.maxH,
        dcDepth: data.defD,
        dcMinDepth: data.minD,
        dcMaxDepth: data.maxD,
        dcHeight2: data.defH2,
        dcMinHeight2: data.minH2,
        dcMaxHeight2: data.maxH2,
        dcDepth2: data.defD2,
        dcMinDepth2: data.minD2,
        dcMaxDepth2: data.maxD2,
        dcBType: data.btype,
        dcBSize: data.bsize,
        dcCType: data.ctype,
        dcCSize: data.csize,
        dcDType: data.dtype,
        dcDSize: data.dsize,
        dcProductCount: 1,
        dcBTypeDisableFlg: data.btypeDisableFlg,
        dcCTypeDisableFlg: data.ctypeDisableFlg,
        dcDTypeDisableFlg: data.dtypeDisableFlg,
        opShelfDisableFlg: data.opShelfDisableFlg,
        opFillerDisableFlg: data.opFillerDisableFlg,
        opShelfType: data.opShelfType,
        opFillerType: data.opFillerType,
        corpData: data.corpData,
        inputReferenceList: data.inputReferenceList,
        cDcProductManual: data.dcProductManual,
        cDcConstructManual: data.dcConstructManual,
        cDcUserManual: data.dcUserManual,
        categoryImg: data.categoryImg,
        categoryName: data.categoryName
      }
      return dcFileData
    },
    changeColorStyle: function (style) {
      this.selectColorStyle = style
      // 初期カラー選択
      this.$nextTick(function () {
        if (this.doorColorList.length > 0) {
          this.selectDoorColor(this.doorColorList[0])
        } else {
          this.selectDoorColor(null)
        }
        if (this.cabineColorList.length > 0) {
          this.selectCabineColor(this.cabineColorList[0])
        } else {
          this.selectCabineColor(null)
        }
        if (this.counterColorList.length > 0) {
          this.selectCounterColor(this.counterColorList[0])
        } else {
          this.selectCounterColor(null)
        }
        console.log('selectedPlan end color')
      })
    },
    filterColorStyleList: function (colorList) {
      return colorList.filter(c => c.style === 0 || c.style === this.selectColorStyle.colorStyleNo)
    },
    isOnReload: function (on) {
      if (on) {
        this.imgReload = this.getImage('common/reload_white.svg')
      } else {
        this.imgReload = this.getImage('common/reload_black.svg')
      }
    },
    isOnSave: function (on) {
      if (on) {
        this.imgSave = this.getImage('common/save_black.svg')
      } else {
        this.imgSave = this.getImage('common/save_orange.svg')
      }
    }
  }, // end methods
  computed: {
    // ヘッダのカート情報
    ...mapState({
      cartData: state => state.cartData
    }),
    nowList: function () {
      if (!this.cartData || Object.keys(this.cartData).length <= 0) return {}
      return this.cartData.cartList.filter(c => c.status === PAYMENT_STATUS.SAVE_CART.code)
    },
    // 全体
    topForm: function () {
      let param = this.$refs.paramCommonRef.getParam()
      let payload = {
        dcFdId: this.targetPlan.dcFdId,
        dcCode: this.targetPlan.dcFdCode,
        dcWidth: param.width,
        dcHeight: param.height,
        dcHeight2: param.height2,
        dcDepth: param.depth,
        dcDepth2: param.depth2,
        dcBType: param.fillerTypeLeft,
        dcBSize: param.fillerSizeLeft,
        dcCType: param.fillerTypeRight,
        dcCSize: param.fillerSizeRight,
        dcDType: param.fillerTypeCounter,
        dcDSize: param.fillerSizeCounter,
        colorStyleNo: this.selectColorStyle.colorStyleNo,
        dcColorDoor: this.colorDoor !== null ? this.colorDoor.id : null,
        dcColorBox: this.colorCabine !== null ? this.colorCabine.id : null,
        dcColorCounter: this.colorCounter !== null ? this.colorCounter.id : null,
        dcShelfCount: this.opShelfCount,
        dcFillerCount: this.isAddFiller ? this.dcFillerCount : 0,
        dcWorkFlag: this.isConstruct,
        dcProductCount: this.targetPlan.dcProductCount,
        dcSaveResrchFlag: this.resrchFlag === 1,
        dcSaveExistDeliFlag: this.isExistDelivery,
        dcSaveDeliPostcd: this.deliveryForm.postcd,
        dcSaveDeliState: this.deliveryForm.state,
        dcSaveDeliCity: this.deliveryForm.city,
        dcSaveDeliStreet: this.deliveryForm.street,
        dcStructPostcd: this.isStructSameAddress ? this.deliveryForm.postcd : this.constructForm.postcd,
        dcStructState: this.isStructSameAddress ? this.deliveryForm.state : this.constructForm.state,
        dcStructCity: this.isStructSameAddress ? this.deliveryForm.city : this.constructForm.city,
        dcStructStreet: this.isStructSameAddress ? this.deliveryForm.street : this.constructForm.street,
        dcConstructOpServiceFlag: this.isCarryFlag,
        businessId: this.selBusiness ? this.selBusiness.businessId : undefined,
        categoryId: this.targetPlan.dcCategoryType,
        makerCorpId: this.targetPlan.corpId,
        colorTypeNo: this.targetPlan.dcFdColorType,
        dcStructSameAddressFlag: this.isStructSameAddress,
        dcSaveExistResrchFlag: false,
        dcSaveSameAddressFlag: this.isResrchSameAddress,
        dcSaveResrchPostcd: this.resrchForm.postcd
      }
      return payload
    },
    // 商品
    isSpaceJoincd: function () {
      if (!this.spaceJoincd) return false
      return true
    },
    // 納品先
    addressList: function () {
      if (!this.businessDataList || Object.keys(this.businessDataList).length <= 0) return []
      return this.businessDataList.map(b => {
        return {
          businessId: b.businessId,
          businessName: b.businessName,
          postcd: b.businessPostcd,
          state: b.businessState,
          city: b.businessCity,
          street: b.businessStreet,
          building: b.businessBuilding,
          userLastName: b.businessPersonLastName1,
          userFirstName: b.businessPersonFirstName1,
          userLastNameKana: b.businessPersonLastNameKana1,
          userFirstNameKana: b.businessPersonFirstNameKana1,
          tel: b.businessTel
        }
      })
    },
    // // スタイル
    // doorColorStyle: function () {
    //   this.colorStyleList.filter()
    // },
    // 色柄の名称
    doorColorTitle: function () {
      if (this.selectColorStyle && Object.keys(this.selectColorStyle).length > 0) {
        return '扉/エンドパネルのカラーをご選択ください。'
      } else {
        return '扉のカラーをご選択ください。'
      }
    },
    // 色柄
    cabineColorList: function () {
      let lColorList = this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.CABINE.code)
      if (this.isExistEndPanel) {
        return this.filterColorStyleList(lColorList)
      }
      return lColorList
    },
    doorColorList: function () {
      let lColorList = this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.DOOR.code)
      if (this.isExistEndPanel) {
        return this.filterColorStyleList(lColorList)
      }
      return lColorList
    },
    counterColorList: function () {
      let lColorList = this.colorList.filter(c => c.type === COLOR_MATERIAL_TYPE.COUNTER.code)
      if (this.isExistEndPanel) {
        return this.filterColorStyleList(lColorList)
      }
      return lColorList
    },
    isExistEndPanel: function () {
      if (this.selectColorStyle && Object.keys(this.selectColorStyle).length > 0) {
        return true
      }
      return false
    },
    // 注文
    isExecOrder: function () {
      if (!this.targetPlan.dcProductCount) return false
      if (this.targetPlan.dcProductCount === '' || Number(this.targetPlan.dcProductCount) <= 0) return false
      if (!this.colorDoor && !this.colorCabine && !this.colorCounter) return false
      if ((this.colorDoor && Object.keys(this.colorDoor).length <= 0) &&
         (this.colorCabine && Object.keys(this.colorCabine).length <= 0) &&
         (this.colorCounter && Object.keys(this.colorCounter).length <= 0)) return false
      if (this.isPlanning) return false
      return true
    },
    getPageList: function () {
      let pageList = []

      if (this.resrchFlag === 1) {
        pageList.push({id: 'order', key: 'orderInput', title: '事前現場調査先入力'})
        pageList.push({id: 'input', key: 'buildingResearchInput', title: '事前現場調査項目入力'})
        pageList.push({id: 'confirm', key: 'orderConfirm', title: '事前現場調査内容確認'})
        pageList.push({id: 'complete', key: 'orderComp', title: '事前現場調査依頼完了'})
      } else {
        pageList.push({id: 'order', key: 'orderInput', title: '納品先入力'})
        if (this.isConstruct) {
          pageList.push({id: 'struct', key: 'struct', title: '組立設置情報入力'})
        }
        pageList.push({id: 'confirm', key: 'orderConfirm', title: 'ご注文内容確認'})
        if (!this.userInfo.isAccountPay) {
          pageList.push({id: 'payment', key: 'payment', title: 'お支払い方法選択'})
        }
        pageList.push({id: 'complete', key: 'orderComp', title: '注文完了'})
      }
      return pageList
    },
    isResearch: function () {
      return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED && this.targetPlan.dcCategoryType !== 5)
    },
    isCarry: function () {
      if (this.targetPlan.corpData.corpId !== 1001) {
        return true
      }
      return false
    },
    estimteBtnTitle: function () {
      if (this.targetPlan.dcCategoryType === 5) return '見積り'
      return '図面/見積り'
    },
    opShelfCount: function () {
      if (this.targetPlan.dcCategoryType === 5) {
        return this.dcBoardCount ? this.dcBoardCount : 0
      }
      return this.isAddShelf ? this.dcShelfCount : 0
    },
    isPlanning: function () {
      // return (this.runPlanList.length > 0 || this.createPlanFlag)
      return this.createPlanFlag
    },
    isCarryFlag: function () {
      // 受け取り搬入が使用可能か
      if (!this.isCarry) return undefined
      if (!this.isResearch) return undefined
      // 施工ありか
      if (!this.workFlag) return 0
      return this.constructOpFlag ? 1 : 0
    },
    isSelectConstruct: function () {
      if (this.targetPlan.dcCategoryType === 4) {
        return !this.isWallEmbedded
      }
      return true
    },
    isConstruct: function () {
      if (!this.isSelectConstruct) return false
      return this.workFlag === 1
    },
    isMiuraCompany: function () {
      if (this.targetPlan.corpData.corpId === 1001) {
        return true
      }
      return false
    },
    fillerSize: function () {
      if (this.isMiuraCompany) {
        return 20
      } else {
        return 15
      }
    }
  }, // end computed
  watch: {
    'deliveryForm.postcd': function () {
      if (this.isStructSameAddress) {
        this.$set(this.constructForm, 'postcd', this.deliveryForm.postcd)
      }
      if (this.isResrchSameAddress) {
        this.$set(this.resrchForm, 'postcd', this.deliveryForm.postcd)
      }
    }
  },
  mounted: function () {
    let saveProduct = App.getLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    if (!saveProduct || Object.keys(saveProduct).length <= 0) {
      // カテゴリ決定
      let lplan = App.getLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
      this.categoryType = lplan.dcCategoryType
      this.$nextTick(function () {
        this.targetPlan = Object.assign({}, lplan)
        this.defaultPlan()
      })
    } else {
      this.readSaveParam(saveProduct.categoryId, saveProduct)
    }
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
  },
  created: function () {
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    this.businessDataList = App.getLocalStorage(DC_STORAGE_KEY.BUSINESS_DATA_LIST)
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.$store.dispatch('loadCartData', {reload: true})
    let pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    if (Object.keys(pageList).length > 0) {
      // 履歴の進むを消す
      history.pushState(null, 'TOP', null)
      App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    }
    this.setPriceCalcTimer()
  }
}
</script>
<style src="../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../css/dc-common.scss" lang="scss" scoped></style>
<style src="../css/dc-customize.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcCustomize.vue